import React from 'react';
import { Route } from 'react-router';

import { PATH } from '../constants/path';

import ModalRoot from './modal/ModalRoot';
import BannerRoot from './banner/BannerRoot';
import HeadComponent from './HeadComponent';
import RouterComponent from './router/RouterComponent';
import ScrollToTopComponent from './ScrollToTopComponent';
import LocalizedBreadcrumbItem from './breadcrumb/LocalizedBreadcrumbsItem';

class App extends React.Component {
    render() {
        return (
            <div id="app">
                <HeadComponent />
                <Route component={RouterComponent} />
                <LocalizedBreadcrumbItem
                    to={PATH.HOME_PATH}
                    showBrandName></LocalizedBreadcrumbItem>
                <ModalRoot />
                <BannerRoot />
                <ScrollToTopComponent />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js